setUserProcessing